export { Pill } from './Pill'
export type { PillColor, PillProps } from './Pill.types'
